export default __webpack_public_path__ + "static/media/655.3f187732.png";